<div class="lopd">
  <div class="map">
    <div class="scroll">
      <div class="table">
        <app-lopd-puig [language]="language"></app-lopd-puig>
      </div>
    </div>
  </div>
</div>
